import { IconButton } from '@chronosphereio/chrono-ui';
import { ArrowDown, ArrowUp } from 'mdi-material-ui';

type ChangeOrderButtonsProps = {
  isLast: boolean;
  isFirst: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
};

export function ChangeOrderButtons({ isLast, isFirst, onMoveUp, onMoveDown }: ChangeOrderButtonsProps) {
  return (
    <>
      <IconButton onClick={onMoveUp} disabled={isFirst}>
        <ArrowUp />
      </IconButton>

      <IconButton onClick={onMoveDown} disabled={isLast}>
        <ArrowDown />
      </IconButton>
    </>
  );
}
